import { render } from "./App.vue?vue&type=template&id=466ac3de&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=466ac3de&lang=scss&scoped=true"

import exportComponent from "E:\\工作\\新旅视界网络科技有限公司\\达人令\\webapp\\drl-live-jk\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466ac3de"]])

export default __exports__